import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("qie_token");
    const cached = localStorage.getItem("qie_user");
    if (token && cached) {
      try { setUser(JSON.parse(cached)); } catch (e) { console.warn("Failed to parse cached user", e); }
      api.get("/auth/me").then(({ data }) => {
        setUser(data);
        localStorage.setItem("qie_user", JSON.stringify(data));
      }).catch((e) => console.warn("auth/me failed", e?.message || e)).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
    // Intentional: hydrate auth once on mount only
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("qie_token", data.token);
    const userWithFlag = { ...data.user, must_change_password: data.must_change_password };
    localStorage.setItem("qie_user", JSON.stringify(userWithFlag));
    setUser(userWithFlag);
    return userWithFlag;
  };

  const logout = () => {
    localStorage.removeItem("qie_token");
    localStorage.removeItem("qie_user");
    setUser(null);
  };

  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    localStorage.setItem("qie_user", JSON.stringify(data));
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
